import Grid from '@mui/material/Grid';
import Box from '@mui/material/Box';
import Layout from '../../../componentsv2/Layout';
import Skeleton from '../../../componentsv2/Skeleton';

export default function BankingReportingSkeleton() {
  return (
    <Layout>
      <Grid container rowSpacing={2}>
        <Grid item xs={12}>
          <Grid container rowSpacing={1}>
            <Grid item xs={12}>
              <Skeleton variant="rectangular" width="40%" height="36px" animation="wave" />
            </Grid>
            <Grid item xs={12}>
              <Skeleton variant="rectangular" width="60%" height="21px" animation="wave" />
            </Grid>
          </Grid>
        </Grid>
        <Grid item xs={12} md={6} sx={{ display: 'flex', flex: 1 }}>
          <Box
            sx={{
              backgroundColor: '#fff',
              minHeight: '140px',
              borderRadius: '12px',
              padding: '1em 2em',
              width: '100%',
            }}
          >
            <Skeleton variant="rectangular" width="100%" height="100%" animation="wave" />
          </Box>
        </Grid>
        <Grid item xs={12} md={6} sx={{ display: 'flex', flex: 1 }}>
          <Box
            sx={{
              backgroundColor: '#fff',
              minHeight: '140px',
              borderRadius: '12px',
              padding: '1em 2em',
              width: '100%',
            }}
          >
            <Skeleton variant="rectangular" width="100%" height="100%" animation="wave" />
          </Box>
        </Grid>
      </Grid>
    </Layout>
  );
}
